import { OrderPlanningEquipment } from "../OrderPlanningEquipment";
import { OrderPlanningOrders } from "../OrderPlanningOrders";
import { Layout, Splitter } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningSplitView extends Layout {
    layoutOrderPlanningEquipment: OrderPlanningEquipment;
    layoutOrderPlanningOrders: OrderPlanningOrders;
    splitterPlanning: Splitter;
}
